import React from "react";
import { Container, Grid, Card, CardContent, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Sidebar from "../../../shared/components/Sidebar.tsx";
import StatsCard from "../components/StatsCard.tsx";  // Jika Anda menggunakan StatsCard
import GraphWidget from "../components/GraphWidget.tsx";
import MapWidget from "../components/MapWidget.tsx";

const Dashboard = () => {
  return (
    <div >
      {/* Sidebar */}
      {/* <Sidebar /> */}

      {/* Main Content */}
      <Container maxWidth="lg" style={{ paddingTop: 24 }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Dashboard
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Welcome to your personalized dashboard. Enjoy the insights!
          </Typography>
        </motion.div>

        {/* Stats Cards (Opsional) */}
        <Grid container spacing={3} style={{ marginTop: 16 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatsCard title="Total Sales" value="$12,340" subtitle="Compared to last month" color="#4caf50" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatsCard title="Projects" value="24" subtitle="Active this week" color="#2196f3" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatsCard title="Assets" value="132" subtitle="Under Management" color="#ff9800" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatsCard title="Vendors" value="8" subtitle="Contracted" color="#9c27b0" />
          </Grid>
        </Grid>

        {/* Graph & Map Row */}
        <Grid container spacing={3} style={{ marginTop: 16 }}>
          <Grid item xs={12} md={6}>
            <GraphWidget />
          </Grid>
          <Grid item xs={12} md={6}>
            <MapWidget />
          </Grid>
        </Grid>

        {/* Additional Cards (Opsional) */}
        <Grid container spacing={3} style={{ marginTop: 16 }}>
          <Grid item xs={12} sm={6} md={4}>
            <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.3 }}>
              <Card>
                <CardContent>
                  <Typography variant="h5" fontWeight="bold">
                    Sales Overview
                  </Typography>
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    Summary of sales and performance metrics.
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
          {/* Tambahkan kartu lain di sini */}
        </Grid>
      </Container>
    </div>
  );
};

export default Dashboard;
